import Referencial from './Referencial';

export default Referencial;
